import React from 'react'
import styled, { css } from 'styled-components'

const StyledPageHeader = styled.section`
  > main {
    background-color: ${({ theme }) => theme.colors.darkBlue};
    min-height: 488px;
    padding: 120px 24px 48px 24px;
    position: relative;
    width: 100%;

    ${({ smallHeight }) =>
      smallHeight &&
      css`
        min-height: 384px;
        padding-top: 140px;
      `}

    ${({ theme }) => theme.media.desktop} {
      padding: 124px 0 0 0;
    }

    sub {
      color: #8a94a6;
    }

    h1,
    h2,
    h3 {
      color: #fff;
    }

    h4 {
      color: #8a94a6;
    }

    p {
      color: #fff;

      strong {
        color: #fff;
        font-weight: 500;
      }
    }
  }

  > header, > section {
    width: 100%;
  }

  > main {
    .gatsby-image-wrapper,
    .mailgun-image-wrapper {
      box-shadow: 0 32px 40px -2px rgba(10, 22, 70, 0.12),
      0 0 1px 0 rgba(10, 22, 70, 0.06);
      border-radius: 8px;
      margin-bottom: -10px;
      margin-top: -50px;
      overflow: hidden;

      ${({ theme }) => theme.media.desktop} {
        margin-bottom: 10px;
        margin-top: -80px;
      }
  
      img {
        width: 100%;
      }
    }
  }

  > section, > article, > footer {
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(251, 251, 252);
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  > article {
    background-color: ${({ theme }) => theme.colors.white};
    min-height: 476px;
  }

  > article.company {
    .gatsby-image-wrapper {
      margin-bottom: 32px;
      margin-top: -132px;
      overflow: hidden;
      position: relative;
      width: 60%;
    }
  }

  ${({ theme }) => theme.media.desktop} {
    > main {
      padding-top: 176px;

      ${({ removePadding }) =>
        removePadding &&
        css`
          min-height: 294px;
          padding-top: 8px;
        `}
    }

    > footer {
      padding: 62px 0 88px;

      .gatsby-image-wrapper,
      .mailgun-image-wrapper {
        margin-bottom: 88px;
        width: 818px;
      }
    }

    > section {
      padding: 62px 0 88px;

      .gatsby-image-wrapper,
      .mailgun-image-wrapper {
        margin-bottom: 88px;
        width: 318px;
      }
    }

    > article {
      padding: 0 0;
    }

    > article.second {
      margin: 96px auto 0;
      width: 868px;
    }
  }
`

const PageHeader = ({ children, cmsData, removePadding, smallHeight }) => {
	return (
    <StyledPageHeader 
      removePadding={cmsData ? cmsData.removePadding : removePadding}
      smallHeight={cmsData ? cmsData.smallHeight : smallHeight}
    >
      {children}
    </StyledPageHeader>
  )
}

export default PageHeader
